<template>
  <div>
    <VHeader/>
    <div v-if="UID">
      <div v-if="FStatus==1" style="margin-top: 16px;color:red">
        审核已通过 !
      </div>
      <div class="visitor-info">
        <van-cell-group>
          <van-cell title="预约人" :value="FUserName" />
          <van-cell title="预约人电话" :value="FPhoneNo" />
          <van-cell title="预约人公司" :value="FCompany" />
          <van-cell title="身份证号码" :value="FUserIDNo" />
          <van-cell title="到访时间" :value="FDate" />
          <van-cell title="入厂地点" :value="FAdress" />
          <van-cell title="访问类型" :value="FVType" />
          <van-cell title="事由" :value="FMemo" />


          <!-- <van-cell title="来源地地址" :value="FFromArea" />
          <van-cell title="来新区时间" :value="FCTime" />
          <van-cell title="交通方式" :value="FTraffic" />
          <van-cell title="交通方式详情" :value="FTrafficXQ" />
          <van-cell title="新区居住地" :value="FXQArea" />
          <van-cell title="单位负责人" :value="FFZUserName" />
          <van-cell title="负责人电话" :value="FFZPhone" />
          <van-cell title="是否诊断为新冠患者" :value="FZhenDuan" />
          <van-cell title="是否接触新冠患者" :value="FJieChu" /> -->
        </van-cell-group>
      </div>

      <div v-if="FStatus==0" style="margin: 16px;">
        <van-button round block type="info" @click="verify()">
          审核
        </van-button>
      </div>

    </div>
    <div v-else>
      <div style="padding-top:20px ">
        当前路径为非法路径!
      </div>
    </div>
  </div>
</template>

<script>
  import VHeader from './VHeader'
  import {Dialog} from 'vant'

  export default {
    name: 'review',
    data () {
      return {
        guid: this.$route.params.id,
        FUserName: '',
        FPhoneNo: '',
        FDate: '',
        UID:'',
        FStatus:'',
        FMemo:'',
        FVType:'',
        FUserIDNo:'',
        FCompany:'',
        FAdress:'',

        FFromArea:'',
        FCTime:'',
        FTraffic:'',
        FTrafficXQ:'',
        FXQArea:'',
        FFZUserName:'',
        FFZPhone:'',
        FRemark:'',
        FZhenDuan:'',
        FJieChu:'',
      }
    },
    components: {
      VHeader
    },
    mounted () {
      const baseURL = this.GLOBAL.baseURL
      let _this = this
      _this.$ajax
        .get(baseURL + 'visitors/select_visitor', {
          params: {
            FGuid: this.$route.params.id
          },
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        .then(response => {
          // console.log(response);
          var data = response.data
          _this.FUserName = data.FUserName
          _this.FPhoneNo = data.FPhoneNo
          _this.FDate = data.FDate.substr(0,16)
          _this.UID = data.UID
          _this.FStatus = data.FStatus
          _this.FMemo = data.FMemo
          _this.FUserIDNo = data.FUserIDNo.substr(0,14)+'****'
          _this.FVType = data.FVType
          _this.FCompany = data.FCompany
          _this.FAdress = data.FAdress
          _this.FFromArea = data.FFromArea
          _this.FCTime = data.FCTime.substr(0,16)
          _this.FTraffic = data.FTraffic
          _this.FTrafficXQ = data.FTrafficXQ
          _this.FXQArea = data.FXQArea
          _this.FFZUserName = data.FFZUserName
          _this.FFZPhone = data.FFZPhone
          _this.FRemark = data.FRemark
          _this.FZhenDuan = data.FZhenDuan
          _this.FJieChu = data.FJieChu

        })
    },
    methods: {

      verify () {
        const baseURL = this.GLOBAL.baseURL
        let _this = this

        _this.$ajax
          .get(baseURL + 'visitors/verify', {
            params: {
              UID: _this.UID
            }
          })
          .then(response => {
            _this.FStatus=1
            Dialog.alert({
              message: response.data.msg,
            }).then(() => {
              // on close
            })
          })
      },
    }
  }
</script>

<style scoped>
  .visitor-info {
    padding: 20px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/views/verify.vue